import * as React from 'react'
import { BookingOffersAdvancedFiltersStayLengthButton } from '@modules/booking-offers/filters/advanced-filters/booking-offers-advanced-filters-stay-length-button'

const StayDays = [2, 3, 4, 5, 6, 7]

export const BookingOffersAdvancedFiltersStayLength = (): JSX.Element => (
  <div className="d-flex mt-4 flex-wrap">
    <span className="font-xl fw-semi-bold col-sm-4 col-12 lh-1">
      Długość pobytu: <br />
      <small className="fw-light font-sm">max 7 dób</small>
    </span>
    <div className="col-sm-8 col-12 mt-3 mt-sm-0">
      <div className="row g-2">
        {StayDays.map(days => (
          <BookingOffersAdvancedFiltersStayLengthButton days={days} key={days} />
        ))}
      </div>
    </div>
  </div>
)
